import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import Edit from '@/assets/icons/edit.svg';
import { Button } from '@/components/ui/button';
import { Tab } from '@/components/ui/tab';
import { Typography } from '@/components/ui/typography';
import { useOpeningDetails } from '@/contexts/opening-context';

import { GoalStatus } from './types';

interface StatusTabsProps {
  activeTab: GoalStatus;
  setActiveTab: (status: GoalStatus) => void;
}

function StatusTabs({ activeTab, setActiveTab }: StatusTabsProps) {
  const intl = useIntl();
  const { opening, hiringGoal, hiringGoalEditUrl } = useOpeningDetails();

  const handleTabClick = (
    status: GoalStatus,
    e: React.MouseEvent<HTMLAnchorElement>,
  ) => {
    e.preventDefault();
    setActiveTab(status);
  };

  return (
    <>
      <div className="flex items-center gap-4 self-stretch">
        <div className="grow">
          <Typography variant="h5">{opening.title}</Typography>
        </div>
        {hiringGoalEditUrl && (
          <Button variant="secondary" asChild>
            <Link to={hiringGoalEditUrl} target="_blank">
              <img src={Edit} alt="Edit" />
              <FormattedMessage
                defaultMessage="Edit goals"
                description="Button: opens hiring goal editor in new tab for this role"
              />
            </Link>
          </Button>
        )}
      </div>
      <div className="flex h-10 items-start gap-1">
        <Tab
          title={intl.formatMessage({
            defaultMessage: 'Active',
            description: 'Hiring goal tab: goals currently in progress',
          })}
          to=""
          isActive={activeTab === 'active'}
          onClick={e => handleTabClick('active', e)}
        />
        <Tab
          title={intl.formatMessage({
            defaultMessage: 'Past',
            description: 'Hiring goal tab: completed or expired goals',
          })}
          to=""
          isActive={activeTab === 'past'}
          onClick={e => handleTabClick('past', e)}
        />
        <Tab
          title={intl.formatMessage({
            defaultMessage: 'Scheduled',
            description: 'Hiring goal tab: future-dated goals not started yet',
          })}
          to=""
          isActive={activeTab === 'scheduled'}
          onClick={e => handleTabClick('scheduled', e)}
        />
      </div>
    </>
  );
}

export { StatusTabs };
